import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import styled from 'styled-components';

// Composants
import WelcomeScreen from './components/WelcomeScreen';
import TestScreen from './components/TestScreen';
import TestEndScreen from './components/TestEndScreen';
import LoadingScreen from './components/LoadingScreen';

// Context
import { TestProvider } from './context/TestContext';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow-x: hidden;
`;

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState('welcome');

  useEffect(() => {
    // Simulation du chargement initial
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <TestProvider>
      <AppContainer>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            {currentStep === 'welcome' && (
              <WelcomeScreen onStart={() => handleStepChange('test')} />
            )}
            {currentStep === 'test' && (
              <TestScreen onComplete={() => handleStepChange('end')} />
            )}
            {currentStep === 'end' && (
              <TestEndScreen onRestart={() => handleStepChange('welcome')} />
            )}
          </motion.div>
        </AnimatePresence>
        
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '12px',
              color: '#1f2937',
              fontSize: '14px',
              fontWeight: '500',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: 'white',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: 'white',
              },
            },
          }}
        />
      </AppContainer>
    </TestProvider>
  );
};

export default App; 